//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col, Card, Typography, Button, Tag, Tooltip } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { getListWifiData } from "../../methods/Methods";
import Loading from "../../components/Loading";
import { images } from "../../routes/ImageRoutes";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import InfoCardComponent from "../../components/InfoCardComponent";
import WifiUpdate from "./components/WifiUpdate";
import { useCallback, useEffect, useState } from "react";
import { CustomizationWifiItem } from "../../types/common";

const { Text } = Typography;

const MyNetworkList = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [wifiList, setWifiList] = useState<CustomizationWifiItem[]>([]);
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [numberWifi, setNumberWifi] = useState<number>(0);
    const [numberAttempts, setNumberAttempts] = useState<number>(0);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [visible, setVisible] = useState<boolean>(false);
    const confServiceData = useSelector(
        (state: any) => state.configurableService.dataList
    );
    const canEnableWifi = confServiceData.some(
        (service: any) => service.name === "DAF_ACTIVATE_ENABLED_MY_NETWORK" && service.enabled
    );

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            const newIdCliente = generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor;
            setIdCliente(newIdCliente);
        }
    }, [generalData.selectedContract]);

    const fetchWifiList = useCallback(() => {
        if (idCliente) {
            setLoading(true)
            getListWifiData(idCliente)
                .then((response) => {
                    if (response.data.data[0] && response.data.data[0].status === true) {
                        setNumberAttempts(response.data.data[0].intentos_disponibles);
                        const resp = response.data.data[0].data;
                        setWifiList(resp);
                        setNumberWifi(resp.length)
                        setHasError(false);
                    } else {
                        setHasError(true);
                        setMessage(response.data.data[0].message)
                        setNumberWifi(0)
                    }
                    setVisible(response.data.data[0].migrado_ACS);
                    setLoading(false)
                })
                .catch(() => {
                    setLoading(false);
                })
        }
    }, [idCliente]);

    useEffect(() => {
        fetchWifiList();
    }, [fetchWifiList])

    const toggleExpand = (index: number) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <SubDefaultLayout
            title={wifiList.length > 1 ? "Mis Redes" : "Mi Red"}
            needReturn={true}
            navigateTo="/technical-support">
            <>
                {
                    loading ? (
                        <Loading />
                    ) : (
                        <>
                            <InfoCardComponent
                                title="Configura tus redes y dispositivos Wi-Fi"
                                description="Para administrar tus dispositivos es necesario que estén encendidos"
                            />
                            <div style={styles.divRoot}>
                                <Text style={{ ...styles.text, fontSize: 20, color: '#444443' }}>
                                    {`Número de redes: ${numberWifi} `}
                                </Text>
                            </div>
                            <div style={styles.divRoot}>
                                {hasError && !visible ? (
                                    <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot }} >
                                        <Row style={styles.rowPrincipal}>
                                            <Col style={styles.colTextError}>
                                                <Text style={{ ...styles.text, color: '#115ac2' }}>
                                                    {message}
                                                </Text>
                                            </Col>
                                        </Row>
                                    </Card>
                                ) : (
                                    <>
                                        {wifiList.map((item, index) => (
                                            <Card key={index}
                                                bodyStyle={styles.bodyCard}
                                                style={{ ...styles.cardRoot }}
                                            >
                                                <Row style={{ cursor: 'pointer' }} onClick={() => toggleExpand(index)}>
                                                    <Col style={{ width: '15%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingLeft: 20 }}>
                                                        <img style={styles.logoIcon} src={images.megaModem} alt={""} />
                                                        {
                                                            visible ? (
                                                                <Tag
                                                                    color={
                                                                        item.Parametros.find(p => p.nombre === "Enable")?.valor === true ? "#00d865" : "#e10613"
                                                                    }
                                                                    style={{ borderRadius: 10, marginTop: 5 }}>
                                                                    <Text style={styles.textTag}>
                                                                        {item.Parametros.find(p => p.nombre === "Enable")?.valor === true ? "Encendido" : "Apagado"}
                                                                    </Text>
                                                                </Tag>
                                                            ) : null
                                                        }
                                                    </Col>
                                                    <Col style={{ ...styles.colText, width: '35%', paddingLeft: 20 }}>
                                                        <Text style={styles.text}>
                                                            Tipo Red:
                                                        </Text>
                                                        <Text style={styles.textBold} ellipsis>
                                                            {item.Tipo_Wifi}
                                                        </Text>
                                                    </Col>
                                                    <Col style={{ ...styles.colText, width: '45%' }}>
                                                        <Text style={styles.text}>
                                                            Nombre de Red:
                                                        </Text>
                                                        <Tooltip title={item.Parametros.find(p => p.nombre === "SSID")?.valor}>
                                                            <Text style={styles.textBold}>
                                                                {item.Parametros.find(p => p.nombre === "SSID")?.valor}
                                                            </Text>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col style={{ width: '5%', display: 'flex', justifyContent: "end", alignItems: 'center' }}>
                                                        {
                                                            visible && item.estado_modem !== "OFFLINE" ? (
                                                                <Button
                                                                    icon={
                                                                        expandedIndex === index ? (
                                                                            <UpOutlined style={{ color: "#797e84" }} />
                                                                        ) : (
                                                                            <DownOutlined style={{ color: "#797e84" }} />
                                                                        )
                                                                    }
                                                                    onClick={() => toggleExpand(index)}
                                                                    type="text"
                                                                />
                                                            ) : null
                                                        }
                                                    </Col>
                                                </Row>
                                                {visible && item.estado_modem !== "OFFLINE" && expandedIndex === index && (
                                                    <div style={{ ...styles.divRoot }}>
                                                        <WifiUpdate
                                                            idCliente={idCliente}
                                                            data={item}
                                                            attempts={numberAttempts}
                                                            onUpdated={fetchWifiList}
                                                            setLoading={setLoading}
                                                            serviceEnable={canEnableWifi}
                                                        />
                                                    </div>
                                                )}
                                            </Card>
                                        ))}
                                    </>
                                )}
                            </div>
                        </>
                    )
                }
            </>
        </SubDefaultLayout >
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    divRoot: {
        alignItems: 'center',
        display: 'flex',
        width: "100%",
        flexDirection: 'column',
        marginTop: 20
    },
    cardRoot: {
        marginBottom: 20,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
        width: "70%",
    },
    bodyCard: {
        justifyContent: 'center',
        padding: 10
    },
    rowPrincipal: {
        width: '100%',
        padding: 10,
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center'
    },
    colTextError: {
        width: '100%',
        flexDirection: 'column'
    },
    colText: {
        width: '25%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        paddingLeft: 15
    },
    textTag: {
        fontSize: 12, color: "#fff", textAlign: 'center', fontWeight: 500
    },
    text: {
        fontSize: 15,
        color: "#000000",
        textAlign: 'left',
        maxWidth: "100%"
    },
    textBold: {
        fontSize: 15,
        color: "#000000",
        textAlign: 'left',
        fontWeight: 600,
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    logoIcon: {
        resizeMode: 'contain',
        width: 55,
        height: 55,
        paddingRight: 8
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default MyNetworkList;
